import classnames from 'clsx';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';

import style from './style.module.css';

/**
 * @param {object} props
 * @param {string?} props.className
 * @returns {JSX.Element}
 */
export const GlobalEMessage = ({ className = '' }) => {
  return (
    <Text
      className={classnames(style['global-e-message'], className)}
      element='span'
      textType={TextType.Caption}
      value={messages.globaleExplanation}
    />
  );
};
